import React, { useEffect } from "react"
import { StaticNavigation, ConsistentlyProvider } from "@fastly/consistently-vanilla"

import * as styles from "./header.module.css"

const ENV = process.env.GATSBY_ENV || process.env.NODE_ENV || "development"

const Header = () => {
  useEffect(() => {
    if (ENV === "production") {
      return
    }

    const headerNode = document.querySelector(".static-nav")
    const prodLink = "https://www.fastly.com/documentation"
    // Gets the current domain we are using for local/staging
    const origin = document.location.origin
    const currentLink = document.location.origin.includes("localhost") ? origin : `${origin}/documentation`

    const updateLinks = () => {
      const links = document.querySelectorAll(".static-nav a")
      links.forEach((link) => {
        if (link.href.includes(prodLink)) {
          link.href = link.href.replace(prodLink, currentLink)
        }
      })
    }

    updateLinks()

    // Create observer to watch for changes within the Header
    const observer = new MutationObserver(updateLinks)
    observer.observe(headerNode, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [])

  return (
    <ConsistentlyProvider reset theme={styles.unifiedHeader}>
      <div className="static-nav">
        <StaticNavigation />
      </div>
    </ConsistentlyProvider>
  )
}

export default Header
